import { gql } from '@apollo/client';

export const FILTERED_STAKEHOLDER_ROLES = gql`
  query filteredStakeholderRoles($input: StakeholderRoleFilter) {
    filteredStakeholderRoles(input: $input) {
      id
      name
    }
  }
`;
